import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from './../../shared/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataUtils } from './../../shared/utils/data-utils';
import * as moment from 'moment';
import { BookingOffer } from './../../models/bookings/bookings.model';

@Component({
  selector: 'swb-bookings-window',
  templateUrl: './bookings-window.component.html'
})
export class BookingsWindowComponent implements OnInit, OnDestroy {

  private _subscription: Subscription;

  private _id: string;
  public day: string;
  public dayObject: Date;

  public showConfirmation: boolean;
  public toCancelId: number;
  public toReactivateId: number;

  public header = 'Booking detail';

  public bookingoffer: BookingOffer;

  public isInitialized = false;

  public cancelled_reason = '';

  constructor(
    private _apiService: ApiService,
    private _route: ActivatedRoute
  ) { }

  public ngOnInit(): void {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
      this.day = this._route.snapshot.params['day'];
      this._getBookings();
    }
  }

  public ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  public getTitle(titleObject: any): string {
    return DataUtils.getTitle(titleObject);
  }

  public getDate(dateString: string): Date {
    return moment(dateString).toDate();
  }

  public prepareCancel(id: number): void {
    this.toCancelId = id;
    this.showConfirmation = true;
  }

  public prepareReactivate(id: number): void {
    this.toReactivateId = id;
    this.showConfirmation = true;
  }

  public resetConfirmation(): void {
    this.toCancelId = undefined;
    this.toReactivateId = undefined;
    this.cancelled_reason = '';
    this.showConfirmation = false;
  }

  public toggleBooking(): void {
    this.isInitialized = false;
    const id = this.toCancelId || this.toReactivateId;
    this._subscription = this._apiService.put({ cancelled_reason: this.cancelled_reason, cancelled: this.toCancelId ? true : false },
      `item_bookings/toggle_cancel/${id}`)
      .subscribe(
        (data: any) => {
          this.resetConfirmation();
          this._getBookings();
        }
      );
  }

  private _getBookings(): void {
    this._subscription = this._apiService.get(`booking-offers/${this._id}/${this.day}`)
      .subscribe(
        (data: any) => {
          this.bookingoffer = data.data;
          this.isInitialized = true;
        }
      );
  }

  public generateArray(obj: string): Array<any> {
    obj = JSON.parse(obj);
    return Object.keys(obj).map((key) => ({ key: key, value: obj[key] }));
  }

  public hasBookings(): boolean {
    return this.bookingoffer
      && this.bookingoffer.booking_items
      && this.bookingoffer.booking_items.some(i => i.item_bookings.length > 0);
  }

}
